/**
 * @file Endpoints.ts
 * @module Endpoints
 * @description API galapunktu konfigurācija. Automātiski nosaka lokālās izstrādes vai
 *              ražošanas vidi un atrisina pareizos ĢIS datu servisa URL REST API,
 *              WebSocket savienojumiem un slāņu flīžu servisiem.
 */

/** Whether the app is running on localhost (development mode) */
export const IS_LOCALHOST = window?.location?.origin?.includes("localhost") || window?.location?.origin?.includes("127.0.0.1");

/** Base URL for REST API requests (Django backend). Points to localhost:8000 in dev, /gis in production */
export const ENTRYPOINT =
	window?.location?.origin?.includes("localhost") || window?.location?.origin?.includes("127.0.0.1") ? "http://127.0.0.1:8000" : window.location.origin + "/gis";

/** WebSocket host for real-time data updates (Kafka message relay for layer refresh) */
export const WEBSOCKET_URL = IS_LOCALHOST ? "sipr.lvc.sungis.lv" : window.location.host;

/** Base URL for layer tile requests. Always uses the production tile server URL in dev to avoid CORS issues */
export const LAYERPOINT = IS_LOCALHOST ? "https://sipr.lvc.sungis.lv/gis" : window.location.origin + "/gis";
